/**
 * Système de notifications global
 * Peut être appelé depuis n'importe où dans l'application
 */

type NotificationCallback = (type: 'success' | 'error' | 'warning' | 'info', message: string) => void;

let globalNotificationHandler: NotificationCallback | null = null;

/**
 * Enregistrer un gestionnaire global de notifications
 * (appelé par NotificationProvider ou autres composants de haut niveau)
 */
export const registerNotificationHandler = (handler: NotificationCallback) => {
  globalNotificationHandler = handler;
};

export const notifications = {
  success: (message: string) => {
    console.log('✅ Success:', message);
    if (globalNotificationHandler) {
      globalNotificationHandler('success', message);
    }
  },

  error: (message: string) => {
    console.error('❌ Error:', message);
    if (globalNotificationHandler) {
      globalNotificationHandler('error', message);
    } else {
      alert(`❌ ${message}`);
    }
  },

  info: (message: string) => {
    console.log('ℹ️ Info:', message);
    if (globalNotificationHandler) {
      globalNotificationHandler('info', message);
    }
  },

  warning: (message: string) => {
    console.warn('⚠️ Warning:', message);
    if (globalNotificationHandler) {
      globalNotificationHandler('warning', message);
    }
  },
};
